module.exports = __webpack_public_path__ + "img/path-1.6b616759.webp";